import { Component, inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { translate } from '@jsverse/transloco';

import { Subject, takeUntil, tap } from 'rxjs';

import { SimpleDialogButtonColor } from 'app/components/simple-dialog.component';
import { AuthService } from 'app/providers/bridge-api/auth.service';
import { SemantriaUser } from 'app/providers/semantria-api/semantria-users.service';
import { AlertService } from 'app/services/alert.service';
import { DialogService } from 'app/services/dialog.service';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { StorageAccountService } from '../../../../providers/storage-api/blender-account.service';
import { UserListService } from '../../services/user-list.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  standalone: false,
})
export class UsersComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  @ViewChild('userList') userListTemplate: TemplateRef<any>;
  @ViewChild('userDetails') userDetailsTemplate: TemplateRef<any>;
  @ViewChild('reportDetails') reportDetailsTemplate: TemplateRef<any>;
  @ViewChild('usageDetails') creditDetailsTemplate: TemplateRef<any>;

  tabBarData = [];

  isAdmin;
  isSaving;
  isLoading = true;
  isViewLoading;

  selectedUser: SemantriaUser;
  userList: SemantriaUser[];

  private unsub$ = new Subject<void>();

  private authService = inject(AuthService);
  private alertService = inject(AlertService);
  private dialogService = inject(DialogService);
  private blenderAccountService = inject(StorageAccountService);
  private userListService = inject(UserListService);

  constructor() {}

  ngOnInit(): void {
    this.isAdmin = this.authService.isAccountAdmin;

    this.userListService.selectedUserChanged
      .pipe(
        takeUntil(this.unsub$),
        tap(() => (this.isViewLoading = false))
      )
      .subscribe((res) => {
        this.selectedUser = res;
      });

    this.userListService.userListChanged
      .pipe(
        takeUntil(this.unsub$),
        tap(() => (this.isLoading = false))
      )
      .subscribe((res) => (this.userList = res));
  }

  onDeleteUser(user: SemantriaUser) {
    this.dialogService
      .showWarningPopup({
        title: translate('user-list.delete-prompt.title'),
        content: translate('user-list.delete-prompt.content'),
        confirmTitle: translate('user-list.delete-prompt.confirm-title'),
        cancelTitle: translate('user-list.delete-prompt.cancel'),
        confirmColor: SimpleDialogButtonColor.red,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.isSaving = true;

          this.blenderAccountService
            .deleteUser(user.user_id)
            .then(() => this.userListService.afterUserDeleted(user))
            .catch((err) => {
              this.isSaving = false;

              this.alertService.showErrorToast(
                translate('user-list.delete-prompt.delete-failure'),
                err
              );
            });
        }
      });
  }

  onReloadUser() {
    this.isViewLoading = true;

    this.userListService.selectedUserNeedsRefresh();
  }

  refreshUsers() {
    this.isViewLoading = true;

    this.userListService.allUsersNeedRefresh();
  }

  setSidePanelLoading($event) {
    this.isLoading = $event;
  }
}
